export default {
	designInfo: {
		bounds: {
			upperLeft: {
				x: 15,
				y: 25
			},
			lowerRight: {
				x: 886,
				y: 73
			}
		},
		stencilSuperIds: [
			"base-multi-select",
			"Component"
		],
		stencilId: "cayuse-org-finder",
		customStencilId: null
	},
	type: "select",
	extraSettings: {
		tagsEnabled: false,
		preselectAll: false,
		enableAutocomplete: true,
		autocompleteMinLength: 1,
		dataSource: "Rest",
		queryUrl: "{{endpoints.cayuse}}/organization?search={{$searchText}}",
		lookupUrl: "{{endpoints.cayuse}}/organization/{{$id}}",
		linkTargetView: "browse",
		formatItem: "{{$item.name}}",
		storage: "Id",
		identity: "id",
		linkTarget: "_blank",
		multi: true
	},
	enabled: true,
	labelAlign: "top",
	value: "{{orgFinderSFI}}",
	size: 12,
	ignore: false,
	visible: true,
	isRequired: false,
	label: "Select Organization",
	i18n: {
		en_us: {	// eslint-disable-line camelcase
			label: "Select Organization"
		}
	},
	cayuseShortLabel: "",
	cayuseShortLabel2: "",
	id: "cayuse-org-finder-sfi",
	cayuseType: "org-finder",
	$path: "orgFinderSFI",
	$errors: [],
	$computedPath: ".extraSettings.layoutDefinition.rows.0.cols.0.extraSettings.layoutDefinition.rows.0.cols.0.extraSettings.sections.7.extraSettings.layoutDefinition.rows.1.cols.0"
};
